export function removeEmptyObject(sources: Record<string, string>) {
    return Object.keys(sources)
    .filter((key) => sources[key] != null)
    .reduce((acc, k) => ({ ...acc, [k]: sources[k]}), {})
}